<template>
  <div id="profile">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && flag"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && flag"></router-view>
  </div>
</template>

<script>

import axios from "axios";
import {loginByDing} from "./api_";
import {Toast} from "vant";

export default {
  name: "App",
  data() {
    return {
      flag: false
    }
  },
  created() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 60000
    })
    this.fetchGetToken()
  },
  mounted() {
    this.handleGetPageWidth()
  },
  methods: {
    handleGetPageWidth() {
      this.$store.commit('SET_CLIENT_WIDTH', document.getElementById('profile').clientWidth)
    },
    fetchGetToken() {
      const u = navigator.userAgent, app = navigator.appVersion;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let token
      if(isiOS){
        token = window.prompt("getToken");
      }else if(window?.jsBridgeHandle?.getToken()){
        token = window?.jsBridgeHandle?.getToken();
      }else{
        token = window.android.getToken();
      }

      const axiosUrl = process.env.VUE_APP_CURENV === "development" ? 'http://eastair-test.bafangintel.cn/api/app/api/user/dd/userId' : 'https://v2eastair.bfintel.cn/api/app/api/user/dd/userId'
      axios.get(axiosUrl, { headers: {'Blade-Auth': 'bearer ' + token} }).then(res => {
        if (res.data.code !== 200) return
        loginByDing({
          dingding: res.data.data,
          grant_type: 'dingding'
        }).then(res => {
          localStorage.setItem("mobile_token", res.access_token)
          this.$store.commit('SET_TOKEN', res.access_token)
          this.$store.commit('SET_USER_ID', res.user_id)
          this.$store.commit('SET_DEPT_ID', res.detail.deptIdLeader)
          this.$store.commit('SET_ROLE_ID', res.role_name)
          let count = 0
          let getTokenFunc = setInterval(() => {
            count++
            if (localStorage.getItem('mobile_token') || this.$store.state.localToken) {
              this.flag = true
              Toast.clear()
              clearInterval(getTokenFunc)
            }
            if (count >= 40) {
              Toast('加载失败，请重新进入!')
              clearInterval(getTokenFunc)
            }
          }, 1000)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#profile{
  height: 100%;
  background: #fff;
  //font-family: 'SourceHanSansSC', serif;
}
</style>
<style>
.van-tab {
  font-size: .14rem !important;
  line-height: .2rem !important;
}
.van-tabs__line {
  width: .16rem !important;
  height: 0.03rem !important;
}
</style>